import { render, staticRenderFns } from "./verifyCode.vue?vue&type=template&id=b9895f06&scoped=true&"
import script from "./verifyCode.vue?vue&type=script&lang=js&"
export * from "./verifyCode.vue?vue&type=script&lang=js&"
import style0 from "./verifyCode.vue?vue&type=style&index=0&id=b9895f06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9895f06",
  null
  
)

export default component.exports